<template>
  <div class="w-full flex flex-col">
    <select-container
      v-if="actions.includes('edit')"
      title="עריכת הביקור"
      subtitle="עריכת שעות הביקור, אורך הביקור ושירותים"
      icon="pi-calendar-clock"
      :no-border="true"
      @click="openEditTimesDrawer"
    />
    <select-container
      v-if="actions.includes('note')"
      title="הוספת סיכום והערות"
      subtitle="הוסיפו סיכום ביקור ותמונות, או הערות עתידיות"
      icon="pi-pen-to-square"
      :no-border="true"
      @click="addNote"
    />
    <select-container
      v-if="actions.includes('cancel')"
      title="ביטול תור"
      subtitle="מחיקת תור מהיומן. הלקוח יקבל הודעת עדכון"
      icon="pi-trash"
      :no-border="true"
      @click="cancelAppointment"
      bg="red"
    />

    <CancelAppointmentConfirm
      v-model:visible="showCancelSmsChoice"
      :default-send-sms="adminAutomations.isCancellationAutomationEnabled"
      :automation-enabled="adminAutomations.isCancellationAutomationEnabled"
      @confirm="handleCancelConfirm" />
  </div>
</template>

<script setup lang="ts">

import { SelectContainer, useDrawer } from '@torim-app/shared-components';
import { PropType, ref } from 'vue';
import { ICustomerTimeline } from '@torim-app/types';
import EditAppointment from '../../modals/EditAppointment.vue';
import { DateTime } from 'luxon';
import { AppointmentsApi } from '@app/api/admin';
import { useToast } from 'vue-toastification';
import NewSummaryNote from '@app/components/admin/modals/NewSummaryNote.vue';
import CancelAppointmentConfirm from '@app/components/admin/modals/CancelAppointmentConfirm.vue';
import { trackEvent } from '@app/composables/posthog';
import { useAdminAutomations } from '@app/stores/admin-automations';

const emit = defineEmits(['completed']);
const props = defineProps({
  actions: {
    type: Array as PropType<Array<'cancel' | 'edit' | 'note'>>,
    required: true,
    default: () => []
  },
  appointment: {
    type: Object as PropType<ICustomerTimeline>,
    required: true,
    default: () => ({})
  }
})

const { closeDrawer, openDrawer } = useDrawer();
const toast = useToast();
const adminAutomations = useAdminAutomations();
const showCancelSmsChoice = ref(false);

const openEditTimesDrawer = () => {
  openDrawer(EditAppointment, {
    appointmentTitle: '',
    appointmentDate: DateTime.fromISO(props.appointment.date).toJSDate(),
    apid: props.appointment.appointmentId,
    recurringManualEventId: props.appointment.recurringManualEventId,
    servicesIds: props.appointment.servicesIds ?? [],
    onComplete: async () => {
      closeDrawer();
      emit('completed')
    },
    onClose: () => {
      closeDrawer();
    }
  }, {
    title: 'עריכת הביקור',
    full: true
  });
};

const cancelAppointment = async () => {
  trackEvent('customer_appointment_canceled');
  showCancelSmsChoice.value = true;
};

const handleCancelConfirm = async (sendSms: boolean, reason?: string) => {
  try {
    await AppointmentsApi.cancelAppointment({ apid: props.appointment.appointmentId, skipNotification: !sendSms, reason });
    toast.success('התור בוטל בהצלחה');
    emit('completed');
    closeDrawer();
  } catch (e) {
    toast.error('לא הצלחנו לבטל את התור');
  }
};

const addNote = () => {
  openDrawer(NewSummaryNote, {
    appointment: props.appointment,
    onClose:() => {
      closeDrawer();
      emit('completed')
    },
  }, {
    title: 'סיכום והערות'
  });
};
</script>

<style scoped lang="scss">

</style>
